import { render, staticRenderFns } from "./zongheConfirmPay.vue?vue&type=template&id=4a44ed3a&scoped=true&"
import script from "./zongheConfirmPay.vue?vue&type=script&lang=js&"
export * from "./zongheConfirmPay.vue?vue&type=script&lang=js&"
import style0 from "./zongheConfirmPay.vue?vue&type=style&index=0&id=4a44ed3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44ed3a",
  null
  
)

export default component.exports